import {
  useScroll,
  useTransform,
  motion,
  AnimatePresence,
} from "framer-motion";
import { homeWorkData } from "../json/HomeWorkData";
import { useState } from "react";
// import { FaGithub } from "react-icons/fa";
import { FaGlobe } from "react-icons/fa";
import { FaRegWindowMaximize } from "react-icons/fa";
import { Link } from "react-router-dom";
import { ArchPorto } from "./archPorto";

const selectedWorksBanner = [
  { id: 1 },
  { id: 2 },
  { id: 3 },
  { id: 4 },
  { id: 5 },
  { id: 6 },
  { id: 7 },
  { id: 8 },
  { id: 9 },
  // { id: 10 },
];

export const SelectedWorks = () => {
  const { scrollYProgress } = useScroll();
  const x = useTransform(scrollYProgress, [0, 1], [0, -3500]);

  // Button View Case
  const [viewCase, setViewCase] = useState(null);

  const toggleViewCase = (index) => {
    setViewCase((prevIndex) => (prevIndex === index ? null : index));
  };

  // Show Project Item animation

  return (
    <>
      <section
        // ref={selectedWorksRef}
        className="bg-[#FfFfFf]"
      >
        <section className="flex items-center gap-[1rem] md:gap-[1rem] pb-[2.5rem] md:pb-[4rem] overflow-hidden">
          {selectedWorksBanner.map((item) => (
            <motion.div
              style={{ x }}
              className="font-spaceGrotesk flex items-center justify-center text-[#001713] text-[6rem] md:text-[12rem]  even:font-thin"
            // className="font-spaceGrotesk flex items-center justify-center text-[#001713] text-[6rem] even:font-thin md:text-[9rem] "
            >
              <span className="tracking-tighter">Works</span>
            </motion.div>
          ))}
        </section>
      </section>
      {/* <section className="px-[16px] md:px-[32px] lg:px-[160px] flex flex-col gap-[4rem] md:gap-[5rem] "> */}
      <section className="px-[16px] md:px-[32px] lg:px-[160px] grid grid-cols-1 md:grid-cols-2 gap-[1.5rem] md:gap-[1.5rem] ">
        {homeWorkData.map((item, index) => (
          <div className="p-[2px] h-max rounded-[1rem] md:rounded-[1.8rem] four-bg-gradient w-full">
            <div
              key={index}
              className="flex flex-col gap-[1rem] md:gap-[1rem] rounded-[0.9rem] md:rounded-[1.7rem] w-full items-center bg-[#fbfdfd] p-[0.75rem] md:p-[1rem]"
            >
              <section className="w-full">
                <img
                  src={item?.imgData[0]}
                  alt=""
                  loading="lazy"
                  className="rounded-[0.8rem] md:rounded-2xl h-[15rem] md:h-[22.5rem] w-full object-cover"
                />
              </section>
              <section className="flex justfify-between w-full font-jakarta flex">
                {/* Title & Roles */}
                <div className="flex flex-col gap-[0.4rem] md:gap-[0.4rem] pl-1">
                  <h1 className="text-[#002921] text-[23px] md:text-[26px] font-semibold transition-colors">
                    {item.title}
                  </h1>
                  <p className="text-[#828997] font-normal text-[16px] md:text-[17px]">
                    {item.role.map((itm, index) => (
                      <span key={index}>
                        {index !== item.role.length - 1 ? `${itm}, ` : itm}
                      </span>
                    ))}
                  </p>
                </div>
                {/* Button */}
                <div className="relative ml-auto mt-auto">
                  <div
                    onMouseEnter={() => toggleViewCase(index)}
                    onMouseLeave={() => toggleViewCase(null)}
                    id="button-animation-two"
                    className="flex items-center justify-center p-[1rem] h-max rounded-full bg-[#E0FD60] hover-scale"
                  >
                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 26 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="rotate-270"
                    >
                      <path
                        d="M10.3291 5.68945H20.6694C20.727 5.68945 20.7738 5.73622 20.7738 5.7939V16.1342"
                        //   stroke="#22333B"
                        stroke-width="2"
                        stroke-miterlimit="10"
                      ></path>
                      <path
                        d="M20.7744 5.68945L7.19629 19.2676"
                        //   stroke="#22333B"
                        stroke-width="2"
                        stroke-miterlimit="10"
                      ></path>
                    </svg>
                  </div>
                  {/*  */}
                  <AnimatePresence>
                    {viewCase === index && (
                      <motion.div
                        initial={{ opacity: 0, y: -65, height: 0 }}
                        animate={{ opacity: 1, y: 0, height: "auto" }}
                        exit={{ opacity: 0, y: -65, height: 0 }}
                        transition={{
                          type: "spring",
                          bounce: 0,
                          duration: 0.7,
                          delay: 0.1
                        }}
                        // onClick={() => toggleViewCase(index)}
                        onMouseEnter={() => toggleViewCase(index)}
                        onMouseLeave={() => toggleViewCase(null)}
                        className=" bg-[#E0FD60] px-[1.2rem] rounded-[1.25rem] absolute bottom-[3.75rem] right-0 w-max text-[#002921] font-medium"
                      >
                        <div className="flex flex-col gap-[0.75rem] py-[1rem] text-[15px]">
                          <Link
                            onClick={() => window.scrollTo({ top: 0 })}
                            to={item.projectLink}
                            className="flex items-center gap-[0.75rem] cursor-pointer"
                          >
                            <FaRegWindowMaximize size={16} />
                            <span>Project Detail</span>
                          </Link>
                          <a
                            href={item.webLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-[0.75rem] cursor-pointer"
                          >
                            <FaGlobe size={18} />
                            <span>View Live</span>
                          </a>
                          {/* <a
                            href={item.githubLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-[0.75rem] cursor-pointer hover:translate-x-1.5 transition ease-in-out delay-150"
                          >
                            <FaGithub size={18} />
                            <span>GitHub</span>
                          </a> */}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </section>
            </div>
          </div>
        ))}
      </section>
      <ArchPorto />
    </>
  );
};
